<template>
    <div :class="`max abs t-0 l-0 round-md no-scroll bg-color-${bgColor}`">
        <div class="max bg-fixed bg-pos-2 alpha-d7" :style="`filter: blur(11px); backgroundImage: url(${bgImg})`"></div>
    </div>
</template>

<script>
    export default {
        name: "matte-widget",
        props: ["bgColor", "bgImg"]
    }
</script>


// WEBPACK FOOTER //
// src/components/matte-widget.vue